<template>
  <CurrencyList v-if="!activeCurrency" />
  <CurrencyDetail
    v-else-if="activeCurrency"
    :active-currency="activeCurrency"
  />
</template>

<script setup>
import CurrencyList from "./currency-boost/CurrencyList.vue";
import CurrencyDetail from "./currency-boost/CurrencyDetail.vue";
import Faq from "../../custom/Faq.vue";
const { categoryPackSlug, currentGameSlug, currentGamePackSlug } =
  useGameComposable();
const { getLocale } = useFunctions();
const gameStore = useGameStore();

const activeCurrency = ref("");
const router = useRouter();
const route = router.currentRoute;

if (route.value.query?.active_currency) {
  activeCurrency.value = route.value.query.active_currency;
}

watch(route, (newVal) => {
  const gamePackSlug = newVal.params.gamePackSlug;
  if (gamePackSlug !== "path-of-exile-2-currency-boost") return;
  if (newVal.query.active_currency) {
    activeCurrency.value = newVal.query.active_currency;
  } else {
    activeCurrency.value = "";
  }
});

const gameFaqs = computed(() => {
  if (gameStore.getGame?.faqs) {
    return gameStore.getGame?.faqs;
  }
  return [];
});
</script>
